<template>

  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >
        {{ token }}

        <v-alert
            v-if="haserror"
            color="pink"
            dark
            border="top"
            icon="mdi-alert-circle"
            transition="scale-transition"
        >
          {{ $t("No reconocemos este usuario y/ contraseña") }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

    import axios from "axios"

    export default {
        name: "passwordrecovery",
        props: {},
        data() {
            return {
                haserror: false,
                refreshToken: "",
                token: ""
            }
        },

        mounted() {
            this.refreshToken = this.$route.params.id
            axios.get(this.$store.state.endpoints.oknewpassword+this.$route.params.id)
                .then(async (response) => {
                    if (response.data.token) {
                        this.$store.commit('updateToken', response.data.token);
                        await this.$store.dispatch('getUser')
                        await this.$router.replace("/mi-cuenta")
                    } else {
                        this.haserror = true
                    }
                })
                .catch(error => {
                    this.haserror = true
                });
        }
    }
</script>



